import { contactInfo } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">{contactInfo.title}</h2>
        <p className="text-sm text-foreground-500 mb-10 max-w-lg mx-auto leading-relaxed">{contactInfo.desc}</p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div className="p-5 rounded-xl bg-background-50 border border-background-200">
            <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-3">
              <i className="ri-mail-line text-xl text-primary-600"></i>
            </div>
            <p className="text-xs text-foreground-500 mb-1">电子邮箱</p>
            <p className="text-sm font-medium text-foreground-800">{contactInfo.email}</p>
          </div>

          <div className="p-5 rounded-xl bg-background-50 border border-background-200">
            <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mx-auto mb-3">
              <i className="ri-wechat-line text-xl text-accent-600"></i>
            </div>
            <p className="text-xs text-foreground-500 mb-1">微信公众号</p>
            <p className="text-sm font-medium text-foreground-800">{contactInfo.wechat}</p>
          </div>

          <div className="p-5 rounded-xl bg-background-50 border border-background-200">
            <div className="w-12 h-12 rounded-xl bg-secondary-100 flex items-center justify-center mx-auto mb-3">
              <i className="ri-weibo-line text-xl text-secondary-600"></i>
            </div>
            <p className="text-xs text-foreground-500 mb-1">微博</p>
            <p className="text-sm font-medium text-foreground-800">{contactInfo.weibo}</p>
          </div>
        </div>
      </div>
    </section>
  );
}